import { h, render, Component } from 'preact';
import isEmpty from 'lodash.isempty';
// Import the component as we are using the same classes that are used by mdc dialog
// import Dialog from '../../../elements/material-dialog';

import styles from './index.scss';

export default class CustomDialog extends Component {

	constructor(props) {
		super(props);
		this.addedScrollLockClass = false;
		this.makeFooterPositionFixed = false;
		this.id = (new Date()).getTime() + '';
	}

	componentDidMount() {
		// window.addEventListener('click', this.handleClose);

		if (this.props.showDialog) {
			const body = document.getElementsByTagName('body')[0];
			if (!body.classList.contains('custom-dialog-scroll-lock')) {
				body.classList.add('custom-dialog-scroll-lock');
				this.addedScrollLockClass = true;
			}
		}
	}

	componentDidUpdate() {
		if (this.props.showDialog) {
			const body = document.getElementsByTagName('body')[0];
			if (!body.classList.contains('custom-dialog-scroll-lock')) {
				body.classList.add('custom-dialog-scroll-lock');
				this.addedScrollLockClass = true;
			}
		}
		else if (this.addedScrollLockClass) {
			const body = document.getElementsByTagName('body')[0];
			if (body.classList.contains('custom-dialog-scroll-lock')) {
				body.classList.remove('custom-dialog-scroll-lock');
				this.addedScrollLockClass = false;
			}
		}

		if (this.props.showDialog && this.props.sticky && this.footerRef) {
			const footerHeight = this.footerRef.getBoundingClientRect().height;
			const dialogBody = document.getElementById(this.id+'_body');
			if (dialogBody && dialogBody.style) {
				dialogBody.style.marginBottom = footerHeight + 'px';
			}
		}
	}

	componentWillUnmount() {
		if (this.addedScrollLockClass) {
			const body = document.getElementsByTagName('body')[0];
			if (body.classList.contains('custom-dialog-scroll-lock')) {
				body.classList.remove('custom-dialog-scroll-lock');
				this.addedScrollLockClass = false;
			}
		}
	}

	handleClose = (e) => {
		const { showDialog, onClose } = this.props;

		if (showDialog && typeof onClose === 'function') {
			onClose(e);
		}
	}

	isFooter = (footer) => {
		if ((typeof footer === 'function' || !isEmpty(footer)) && this.props.full) {
			return true;
		}
		return false;
	}

	render() {
		const { showDialog = false, header, footer, body, bodyClass, className, full = false, footerClass, sticky } = this.props;

		if (!showDialog) {
			return null;
		}

		// return (<div class={`mdc-dialog mdc-dialog--animating mdc-dialog--open ${className ? className : ''}`}>
		// 	<div class={`mdc-dialog__surface ${full && 'mdc-dialog__full'} ${!full && 'mdc-dialog__sm'}`}>
		// 		{header && <div ref={(ref) => { this.headerRef = ref; }} class="mdc-dialog__header">
		// 			{typeof header === 'function' ? header() : header}
		// 		</div>}
		// 		{body && <section ref={(ref) => { this.bodyRef = ref; }} class={`mdc-dialog__body mdc-dialog__body--scrollable ${bodyClass ? bodyClass : ''} ${this.isFooter(footer) ? 'footer--space' : ''}`}>
		// 			{typeof body === 'function' ? body() : body}
		// 		</section>}
		// 		{footer && <div ref={(ref) => { this.footerRef = ref; }} class={`mdc-dialog__footer ${footerClass ? footerClass : ''}`}>
		// 			{typeof footer === 'function' ? footer() : footer}
		// 		</div>}
		// 	</div>
		// 	<div class="mdc-dialog__overlay"></div>
		// </div>);

		return (
			<BaseModal>
				<div class={`custom-dialog custom-dialog--animating custom-dialog--open ${className ? className : ''}`}>
					<div class={`custom-dialog__surface ${full && 'custom-dialog__full'}`}>
						{header && <div ref={(ref) => { this.headerRef = ref; }} class="custom-dialog__header">
							{typeof header === 'function' ? header() : header}
						</div>}
						{body && <section ref={(ref) => { this.bodyRef = ref; }} class={`custom-dialog__body ${full ? 'custom-dialog__body--scrollable' : ''} ${bodyClass ? bodyClass : ''}`}>
							{typeof body === 'function' ?
								<div id={this.id + '_body'}>{body()}</div> :
								<div id={this.id + '_body'}>{body}</div>
							}
							{footer && <div ref={(ref) => { this.footerRef = ref; }} class={`custom-dialog__footer ${footerClass ? footerClass : ''}${sticky ? 'sticky' : ''}`}>
								{typeof footer === 'function' ? footer() : footer}
							</div>}
						</section>}
					</div>
					<div class="custom-dialog__overlay" onClick={this.handleClose} />
				</div>
			</BaseModal>
		);
	}
}

class ContextProvider extends Component {
	getChildContext() {
		return this.props.context;
	}
	render() {
		return this.props.children && this.props.children[0];
	}
}

class BaseModal extends Component {

	renderChildren() {
		return (
			<div id={this.id}>
				<ContextProvider context={this.context}>
					{this.props.children}
				</ContextProvider>
			</div>
		);
	}

	constructor(props) {
		super(props);
		this.id = (new Date()).getTime() + '';
		this.element = '';
	}

	// Using WillMount isntead of DidMount to make ref's available in parent components
	componentWillMount() {
		this.target = document.getElementById('modal-div');
		if (!this.target) {
			const el = document.createElement('div');
			el.setAttribute('id', 'modal-div');
			document.body.appendChild(el);
			this.target = el;
		}
		this.element = render(this.renderChildren(), this.target);
	}

	componentDidUpdate() {
		this.element = render(this.renderChildren(), this.target, this.element);
	}

	componentWillUnmount() {
		const element = this.element;
		if (element && element.parentElement) {
			element.parentElement.removeChild(this.element);
		}
	}

	render() {
		return <div />;
	}
}


// WEBPACK FOOTER //
// ../q-mdc/quikr/core/customDialog/index.js